import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyC-WO2AAa8TJOishfSu704F3HELUnVCMbQ',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'neoapps-website.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'neoapps-website',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'neoapps-website.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '682317816047',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:682317816047:web:e814df67c1bd8aafe93b1a',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-8V1DKZ683D',
};

export const firebaseApp = initializeApp(firebaseConfig);

let analyticsInstance = null;
let analyticsPromise = null;

export const getFirebaseAnalytics = () => {
  if (typeof window === 'undefined') {
    return Promise.resolve(null);
  }

  if (analyticsInstance) {
    return Promise.resolve(analyticsInstance);
  }

  if (!analyticsPromise) {
    analyticsPromise = isSupported()
      .then((supported) => {
        if (!supported) {
          return null;
        }

        analyticsInstance = getAnalytics(firebaseApp);
        return analyticsInstance;
      })
      .catch(() => null);
  }

  return analyticsPromise;
};
